<!-- <c-offcanvas [class]="level|offCanvasClass" backdrop="static" placement="end" [id]="id">
  <div id="optima-offcanvas-form-content">
    <c-offcanvas-header>
      <div style="display:flex; flex-direction: row">
        <div>
          <button cButtonClose class="text-reset" (click)="onCloseButtonClicked()" aria-label="Close"></button>
        </div>
        <div class="mx-4">
          <app-progress-indicator [showMessage]="true" ></app-progress-indicator>
        </div>
      </div>
    </c-offcanvas-header>
    <c-offcanvas-body>
      @if(id | offcanvasLevelCheck : level : offCanvasFormService.currentHighestLevel){

      
      } @else if(renderErrors) {<div style="height:200px;flex:1;background-color: darkorange; color:white; padding:1rem"><h1>Render Failed</h1><p>OffCanvas is being tried to open directly instead of new method!</p></div>}
    </c-offcanvas-body>
  </div>
</c-offcanvas> -->

<optima-off-canvas [id]="id" [placement]="placement" [level]="level">
  <button cButtonClose slot="header" class="text-reset" (click)="onCloseButtonClicked()" aria-label="Close"></button>
  <ng-container slot="body">
    @if(id | offcanvasLevelCheck : level : offCanvasFormService.currentHighestLevel){

    @if( level | formSelector: offCanvasFormService: offCanvasComponents.Objective){
    <app-form-objective></app-form-objective>
    }

    @if( level | formSelector: offCanvasFormService: offCanvasComponents.Deliverable){
    <app-form-deliverable></app-form-deliverable>
    }

    @if( level | formSelector: offCanvasFormService: offCanvasComponents.BizEntity){
      @if(bizEntity) {
        <app-form-biz-entity [bizEntity]="bizEntity" [isEditing]="isEditing" [excludeParentAndOwner]="false"></app-form-biz-entity>
      }
    }

    @if( level | formSelector: offCanvasFormService: offCanvasComponents.KPI){
    <app-form-kpi></app-form-kpi>
    }

    @if( level | formSelector: offCanvasFormService: offCanvasComponents.Measure){
    <app-form-measure></app-form-measure>
    }

     @if( level | formSelector: offCanvasFormService: offCanvasComponents.TxnLog){
    <app-form-transaction-log></app-form-transaction-log>
    }
    <!-- BizEntity type forms are entirely handled by framework so enum based check is not needed -->
    <!-- @if( level | formSelector: offCanvasFormService: offCanvasComponents.BizEntityType){
      <app-form-biz-entity-type></app-form-biz-entity-type>
    } -->
    @if( level | formSelector: offCanvasFormService: offCanvasComponents.AddDashboard){
      <app-form-add-dashboard></app-form-add-dashboard>
    }
    <!-- For bizEnity we are still using the enum based check, will move in next phase off refactoring -->
     <!-- This is used by frameworks bizEntites (team, system Defined team) -->
    @if(shouldRenderComponent(LibFormBizEntityComponent)){
      @if(bizEntity) {
        <app-form-biz-entity [bizEntity]="bizEntity" [isEditing]="isEditing"></app-form-biz-entity>
      }
    }
    @else if(shouldRenderComponent(LibFormBizEntityTypeComponent)) {
      <app-form-biz-entity-type [isEditing]="isEditing" [editBizEntityType]="bizEntityTypeForEdit"></app-form-biz-entity-type>
    }
    @else if (shouldRenderComponent(LibNavigationComponent)) {
      <lib-notification></lib-notification>
    }
    @else if(shouldRenderComponent(FormSectionComponent)) {
      <app-form-section [bizEntity]="bizEntity!" [isEditing]="isEditing" [parent]="parentForSection"></app-form-section>
    }
    } @else if(renderErrors) {
      <div style="height:200px;flex:1;background-color: darkorange; color:white; padding:1rem">
        <h1>Render Failed</h1>
        <p>OffCanvas is being tried to open directly instead of new method!</p>
      </div>
  }
  </ng-container>
</optima-off-canvas>